import React, { useCallback, useState } from 'react'
import { Form } from 'react-final-form'
import PropTypes from 'prop-types'

import { Text } from 'Components/UI'
import { Button, Flex } from 'Components/UI/_Legacy'
import InputField from 'Components/UI/_Legacy/Input/FormInput'
import Textarea from 'Components/UI/_Legacy/Textarea'
import validate from 'validate.js'

import noop from 'lodash/noop'

import { PHONE_MASK } from 'Constants/Common'

import { Container, FormContainer, Row, SendIcon } from './styles'

const FIELDS = {
  FULL_NAME: 'fullName',
  EMAIL: 'email',
  PHONE: 'phone',
  COMPANY: 'company',
  DESCRIPTION: 'description',
}

const constraints = {
  [FIELDS.FULL_NAME]: {
    presence: true,
  },
  [FIELDS.EMAIL]: {
    presence: true,
    email: true,
  },
}

function ContactAlt({ onSent }) {
  const [isError, setIsError] = useState(false)
  const [isSent, setIsSent] = useState(false)
  const [isSending, setIsSending] = useState(false)

  const submit = useCallback(
    values => {
      setIsSending(true)
      fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },

        body: JSON.stringify({
          ...values,
          subject: `Let's talk!`,
        }),
      }).then(res => {
        setIsSending(false)
        if (res.status === 200) {
          setIsSent(true)
          onSent()
        } else {
          setIsError(true)
        }
      })
    },
    [onSent],
  )

  const renderForm = useCallback(
    ({ handleSubmit }) => (
      <FormContainer>
        <Row
          flexDirection={['column', 'column', 'row']}
          gap={[3, 3, 6]}
          mb={[3, 3, 6]}
        >
          <InputField
            blueprint
            name={FIELDS.FULL_NAME}
            placeholder="Full name*"
            width={1}
          />

          <InputField
            blueprint
            name={FIELDS.EMAIL}
            placeholder="Email*"
            width={1}
          />
        </Row>

        <Row
          flexDirection={['column', 'column', 'row']}
          gap={[3, 3, 6]}
          mb={[3, 3, 6]}
        >
          <InputField
            blueprint
            mask={PHONE_MASK}
            name={FIELDS.PHONE}
            placeholder="Phone number"
            width={1}
          />

          <InputField
            blueprint
            name={FIELDS.COMPANY}
            placeholder="Company"
            width={1}
          />
        </Row>

        <Textarea
          blueprint
          mb={40}
          name={FIELDS.DESCRIPTION}
          placeholder="Short description of your project"
        />

        <Flex justifyContent="center">
          <Button
            blueprint
            disabled={isSending || submit.submitting}
            width={250}
            onClick={handleSubmit}
          >
            <SendIcon />
            Send
          </Button>
        </Flex>
      </FormContainer>
    ),
    [isSending, submit],
  )

  if (isError) {
    return (
      <Container>
        <Text center>
          Sorry, something wrong! <br /> Please try later.
        </Text>
      </Container>
    )
  }
  if (isSent) {
    return (
      <Container>
        <Text center>See your soon!</Text>
      </Container>
    )
  }

  return (
    <Form
      render={renderForm}
      validate={values => validate(values, constraints)}
      onSubmit={submit}
    />
  )
}

ContactAlt.defaultProps = {
  onSent: noop,
}

ContactAlt.propTypes = {
  onSent: PropTypes.func,
}

export default ContactAlt
